'use strict';

const $ = require('jquery');

class pricingSlider {

    constructor() {

        this.toggleDetails();

    }

    toggleDetails() {

        let $detailsTrigger = $('[data-details-trigger]');

        $detailsTrigger.on('click', function(event) {
            event.preventDefault();

            $(this).closest('.plan-sections').toggleClass('open');
        })

    }

}

module.exports = pricingSlider;
